import React, { useState } from 'react'
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ClinicLogo from "../../../Assests/cosmos  Logo.png";
import EMRResponsiveNavbar from "../../EMRResponsiveNavbar/EMRResponsiveNavbar";
import { getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import HealingIcon from '@mui/icons-material/Healing';
import MasksIcon from '@mui/icons-material/Masks';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FactoryIcon from '@mui/icons-material/Factory';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import SmsIcon from '@mui/icons-material/Sms';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { Collapse } from '@mui/material';


export default function PatientSidebar() {
  const [state, setState] = React.useState({ left: false, top: false });
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const location = useLocation();
  const navigate = useNavigate();
  const LoginUserDetails = getDecryptedData();
  const LoginUserType= getDecryptedUserType()
  const [openSection, setOpenSection] = useState(null); // 'clinic', 'wellness', 'membership'


  const fullName = `${LoginUserDetails?.fname || ""} ${LoginUserDetails?.lname || ""}`.trim();

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleLogoutConfirm = () => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.clear();
      setLoading(false);
      setOpenLogoutDialog(false);
      navigate("/provider-signin");
    }, 2000);
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        background: "linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderTopRightRadius: isLargeScreen ? 30 : 0,
        borderBottomRightRadius: 30,
        overflowX: "hidden",
      }}
      role="presentation"
      onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}
      onKeyDown={isLargeScreen ? null : toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
        <img src={ClinicLogo} alt="Hospital Logo" style={{ maxWidth: "100%", maxHeight: 65 }} />
      </Box>
      <Divider />
      {/* <List sx={{ flexGrow: 1 }}>
        {[
          { text: "Dashboard", icon: <DashboardIcon />, path: "/provider/dashboard" },
           { text: "Patients", icon: <PeopleIcon />, path: "/provider/patient-list" },
           { text: "Chat", icon: <SmsIcon />, path: "/provider/send-messages" },
           { text: "Appointments", icon: <EventNoteIcon />, path: "/provider/appointments" },
          { text: "My Schedule", icon: <CalendarMonthIcon />, path: "/provider/my-schedule" },
          { text: "My Services", icon: <LocalHospitalIcon />, path: "/provider/my-services" },
          { text: "Drugs", icon: <VaccinesIcon />, path: "/provider/drugs" },
          ...(
            LoginUserType === "admin"
      ? [
          { text: "Doctors", icon: <MasksIcon />, path: "/provider/all-doctors" },
          { text: "Clinic Services", icon: <HealingIcon />, path: "/provider/clinic-services" },
          { text: "Inventory", icon: <FactoryIcon />, path: "/provider/inventory-handling" },
          { text: "Exercises", icon: <SportsGymnasticsIcon />, path: "/provider/exercises-handling" },
          { text: "Workouts", icon: <FitnessCenterIcon />, path: "/provider/all-workouts" },
          { text: "Enquiries", icon: <DisplaySettingsIcon />, path: "/provider/all-enquiries" },
          { text: "Benefits", icon: <LoyaltyIcon />, path: "/provider/all-benefits" },
          { text: "Membership", icon: <CardMembershipIcon />, path: "/provider/all-membership" },
          { text: "Membership Groups", icon: <Diversity3Icon />, path: "/provider/membership-groups" },
          { text: "AI Diet", icon: <RestaurantIcon />, path: "/provider/ai-diet-questions" },
          { text: "Facilities", icon: <AccessTimeIcon />, path: "/provider/facilities" },
        ]
      : []
      
      ),
        ].map((item) => (
          <ListItem
            key={item.text}
            disablePadding
            sx={{
              backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
              width: "100%",
            }}
          >
            <Link to={item.path} style={{ textDecoration: "none", color: "white", width: "100%" }}>
              <ListItemButton onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}>
                <ListItemIcon style={{ color: "white" }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List> */}

      <List sx={{ flexGrow: 1 }}>
  {/* Common Routes */}
  {[
    { text: "Dashboard", icon: <DashboardIcon />, path: "/provider/dashboard" },
    { text: "Patients", icon: <PeopleIcon />, path: "/provider/patient-list" },
    { text: "Chat", icon: <SmsIcon />, path: "/provider/send-messages" },
    { text: "Appointments", icon: <EventNoteIcon />, path: "/provider/appointments" },
    { text: "My Schedule", icon: <CalendarMonthIcon />, path: "/provider/my-schedule" },
    { text: "My Services", icon: <LocalHospitalIcon />, path: "/provider/my-services" },
    { text: "Drugs", icon: <VaccinesIcon />, path: "/provider/drugs" },
  ].map((item) => (
    <ListItem
      key={item.text}
      disablePadding
      sx={{
        backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit",
        "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
        width: "100%",
      }}
    >
      <Link to={item.path} style={{ textDecoration: "none", color: "white", width: "100%" }}>
        <ListItemButton onClick={isLargeScreen ? null : toggleDrawer("left", false)}>
          <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      </Link>
    </ListItem>
  ))}

  {/* Admin-Only Routes Grouped */}
  {LoginUserType === "admin" && (
    <>
      {/* Clinic Management */}
      <ListItemButton onClick={() => setOpenSection(openSection === 'clinic' ? null : 'clinic')} sx={{ color: "white" }}>
        <ListItemIcon sx={{ color: "white" }}><LocalHospitalIcon /></ListItemIcon>
        <ListItemText primary="Clinic Management" />
         {openSection === 'clinic' ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openSection === 'clinic'} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {[
            { text: "Doctors", path: "/provider/all-doctors", icon: <MasksIcon /> },
            { text: "Clinic Services", path: "/provider/clinic-services", icon: <HealingIcon /> },
            { text: "Facilities", path: "/provider/facilities", icon: <AccessTimeIcon /> },
          ].map((item) => (
            <ListItemButton
              key={item.text}
              sx={{ pl: 4, color: "white", backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit" }}
              component={Link}
              to={item.path}
            >
              <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

      {/* Wellness */}
      <ListItemButton onClick={() => setOpenSection(openSection === 'wellness' ? null : 'wellness')} sx={{ color: "white" }}>
        <ListItemIcon sx={{ color: "white" }}><FitnessCenterIcon /></ListItemIcon>
        <ListItemText primary="Wellness" />
        {openSection === 'wellness' ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openSection === 'wellness'} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {[
            { text: "Inventory", path: "/provider/inventory-handling", icon: <FactoryIcon /> },
            { text: "Exercises", path: "/provider/exercises-handling", icon: <SportsGymnasticsIcon /> },
            { text: "Workouts", path: "/provider/all-workouts", icon: <FitnessCenterIcon /> },
            { text: "AI Diet", path: "/provider/ai-diet-questions", icon: <RestaurantIcon /> },
          ].map((item) => (
            <ListItemButton
              key={item.text}
              sx={{ pl: 4, color: "white", backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit" }}
              component={Link}
              to={item.path}
            >
              <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

      {/* Membership */}
      <ListItemButton onClick={() => setOpenSection(openSection === 'membership' ? null : 'membership')} sx={{ color: "white" }}>
        <ListItemIcon sx={{ color: "white" }}><CardMembershipIcon /></ListItemIcon>
        <ListItemText primary="Membership" />
         {openSection === 'membership' ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openSection === 'membership'} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {[
            { text: "Membership", path: "/provider/all-membership", icon: <CardMembershipIcon /> },
            { text: "Membership Groups", path: "/provider/membership-groups", icon: <Diversity3Icon /> },
            { text: "Benefits", path: "/provider/all-benefits", icon: <LoyaltyIcon /> },
          ].map((item) => (
            <ListItemButton
              key={item.text}
              sx={{ pl: 4, color: "white", backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit" }}
              component={Link}
              to={item.path}
            >
              <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

      {/* Other Admin Route */}
      <ListItem
        disablePadding
        sx={{
          backgroundColor: location.pathname === "/provider/all-enquiries" ? "rgb(255 255 255 / 62%)" : "inherit",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
          width: "100%",
        }}
      >
        <Link to="/provider/all-enquiries" style={{ textDecoration: "none", color: "white", width: "100%" }}>
          <ListItemButton>
            <ListItemIcon sx={{ color: "white" }}><DisplaySettingsIcon /></ListItemIcon>
            <ListItemText primary="Enquiries" />
          </ListItemButton>
        </Link>
      </ListItem>
    </>
  )}
</List>

      {/* User Profile */}
      {fullName && (
        <ListItem disablePadding sx={{ width: "100%", mt: "auto" }}>
          <ListItemButton component={Link} to="/patient/profile" sx={{ color: "white" }}>
            <ListItemIcon sx={{ color: "white" }}>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={fullName} />
          </ListItemButton>
        </ListItem>
      )}

      {/* Logout Button */}
      <Box sx={{ paddingBottom: "10px" }}>
        <Divider />
        <ListItem disablePadding sx={{ width: "100%" }}>
          <ListItemButton onClick={() => setOpenLogoutDialog(true)} sx={{ color: "red" }}>
            <ListItemIcon>
              <PowerSettingsNewIcon sx={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{ color: "white", fontWeight: "bold" }} />
          </ListItemButton>
        </ListItem>
      </Box>
    </Box>
  );

  return (
    <div>
      {!isLargeScreen && <EMRResponsiveNavbar toggleDrawer={toggleDrawer} />}
      {isLargeScreen ? (
        <Drawer
          variant="permanent"
          anchor="left"
          open
          sx={{
            "& .MuiDrawer-paper": {
              width: 250,
              boxSizing: "border-box",
              background: "linear-gradient(135deg, #ffcbc9 0%, #fea5b8 30%, #e990c6 60%, #c196c1 100%)",
              borderTopRightRadius: 30,
              borderBottomRightRadius: 30,
              overflowX: "hidden",
            },
          }}
        >
          {list("left")}
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor="top"
          open={state.top}
          onClose={toggleDrawer("top", false)}
          onOpen={toggleDrawer("top", true)}
          sx={{
            "& .MuiDrawer-paper": {
              borderBottomLeftRadius: 30,
              borderBottomRightRadius: 30,
              background: "linear-gradient(135deg, #ffcbc9 0%, #fea5b8 30%, #e990c6 60%, #c196c1 100%)",
              overflowX: "hidden",
            },
          }}
        >
          {list("top")}
        </SwipeableDrawer>
      )}

      {/* Logout Confirmation Dialog */}
      <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)}>
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to logout?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenLogoutDialog(false)}>No</Button>
          <Button onClick={handleLogoutConfirm} color="error" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
